import { Box, CircularProgress } from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/Header";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import InventoryForm from "../../../components/FormInventory";
import { useTranslation } from "react-i18next";

const CreateInventory = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const apiUrl = "https://oven-backend.onrender.com";


  const handleFormSubmit = async (values) => {
    setLoading(true);
    setError(null);

    try {
      const formattedValues = {
        ...values,
        totalQuantity: Number(values.totalQuantity),
        minStockLevel: Number(values.minStockLevel),
        unitPrice: Number(values.unitPrice),
        lastPurchaseDate: new Date(values.lastPurchaseDate).toISOString(),
      };

      // إزالة القيم الفارغة
      Object.keys(formattedValues).forEach(
        (key) => formattedValues[key] === "" && delete formattedValues[key]
      );

      await axios.post(`${apiUrl}/inventory`, formattedValues);
      setOpen(true);
      console.log("✅ Inventory item created successfully:", formattedValues);

      setTimeout(() => {
        navigate("/inventory");
      }, 1000);
    } catch (error) {
      console.error("❌ Error creating inventory item:", error.response?.data || error);
      setError(t("error_creating_item"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m="20px">
      <Header title={t("create_inventory_item")} subtitle={t("add_new_inventory_item")} />
      
      <InventoryForm 
        initialValues={{
          itemName: "",
          totalQuantity: "",
          minStockLevel: "",
          supplier: "",
          lastPurchaseDate: "",
          unitPrice: "",
        }}
        handleFormSubmit={handleFormSubmit} 
        buttonLabel={loading ? <CircularProgress size={24} color="inherit" /> : t("create_item")}
        disabled={loading}
      />

      {/* رسالة نجاح */}
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert onClose={() => setOpen(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {t("inventory_item_added")}
        </Alert>
      </Snackbar>

      {/* رسالة خطأ */}
      <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError(null)}>
        <Alert onClose={() => setError(null)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateInventory;
